


























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import outair_threshold from "../../../store/entities/outair_threshold";
@Component
export default class CreateThreshold extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  outair_threshold: outair_threshold = new outair_threshold();
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  save() {
    (this.$refs.thresholdForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "outair_threshold/create",
          data: this.outair_threshold,
        });
        (this.$refs.thresholdForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.thresholdForm as any).resetFields();
    this.$emit("input", false);
  }
  thresholdRule = {
    tName: [{ required: true, message: "请填写阈值方案名称", trigger: "blur" }],
    maxNumber: [{ required: true, message: "请填写最大数量", trigger: "blur" }],
    maxtemp: [{required: true, message: "请填写最大温度", trigger: "blur" }],
    maxhumi: [{required: true, message: "请填写最大湿度", trigger: "blur" }],
    mintemp: [{required: true, message: "请填写最小温度", trigger: "blur" }],
    minhumi: [{required: true, message: "请填写最小湿度", trigger: "blur" }],
    maxpM25: [{required: true, message: "请填写PM2.5", trigger: "blur" }],
    maxpM10: [{required: true, message: "请填写PM10", trigger: "blur" }],
    maxvoc: [{required: true, message: "请填写VOC挥发物", trigger: "blur" }],
    maXwind_speed: [{required: true, message: "请填写风速", trigger: "blur" }],
    maXnoise: [{required: true, message: "请填写噪音", trigger: "blur" }],
    maXpressure: [{required: true, message: "请填写大气压", trigger: "blur" }],
  };
}
